import type {ISelectOption} from 'src/types/Form';
import type {FormFieldTypeV2, IFormFieldV2} from 'src/types/FormV2';
import {FormFieldTypeDisplayNameV2} from 'src/types/FormV2';
import {isMeasurementFieldInvalidForSave} from 'src/app/form-builder/utils/measurementValidation';

/**
 * Field types an equipment type's inspection fields may use — the frontend
 * mirror of the server-side palette allow-list
 * (`EquipmentTypeFieldService`/`FormDefinitionValidator`: Text, Number, Date,
 * DropdownSingle, DropdownMultiModal, Switch, Measurement).
 * Deliberately separate from `FormBuilderFieldTypeV2` — the Forms module
 * builder palette is unchanged by this feature.
 */
export const FieldEditorFieldTypeV2: FormFieldTypeV2[] = [
  'text',
  'number',
  'date',
  'select',
  'select-multiple',
  'switch',
  'measurement',
];

export const FieldEditorFieldTypeOptions: ISelectOption[] = FieldEditorFieldTypeV2.map(
  type => ({id: type, label: FormFieldTypeDisplayNameV2[type]})
).sort((a, b) => a.label.localeCompare(b.label));

/**
 * Whether any measurement field in the list has zero units, or a blank or
 * duplicate unit — derived from the field data itself so it catches fields
 * whose settings panel isn't currently open, not just the selected field.
 */
export function fieldListHasInvalidMeasurementUnits(
  fields: IFormFieldV2[]
): boolean {
  return fields.some(
    field =>
      field.type === 'measurement' &&
      isMeasurementFieldInvalidForSave(field.measurementOptions?.units ?? [])
  );
}
